import { makeStyles } from '@material-ui/core/styles';

const calendarStyle = makeStyles(() => ({
	button: {
		textTransform: 'none',
		borderRadius: '24px',
		'&:hover': {
			background: '#EBE8F3',
		},
		'&:disabled': {
			color: '#B2B0B9',
		},
	},
	applyBtn: {
		background: '#3c228a',
		color: '#ffffff',
		'&:hover': {
			backgroundColor: '#7063A6',
			color: '#ffffff',
		},
	},
	cancelBtn: {
		background: '#ffffff',
		color: '#3c228a',
		marginRight: '16px',
	},
	label: {
		fontFamily: 'Bogle-Medium',
		fontSize: 14,
		cursor: 'pointer',
		lineHeight: '20px',
		fontWeight: '500',
	},
}));

export default calendarStyle;
